"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.top = exports.right = exports.left = exports.bottom = exports.all = void 0;
require("./pin.css");
const top = "cds-top-t1kl5qaj";
exports.top = top;
const bottom = "cds-bottom-b1t66uwj";
exports.bottom = bottom;
const left = "cds-left-lmvakyd";
exports.left = left;
const right = "cds-right-r1fsk237";
exports.right = right;
const all = "cds-all-a1uyshm4";
exports.all = all;